module.exports = __webpack_public_path__ + "img/project-2.6b498335.png";